/**
 * WHAT: Contact Page Initialization Module
 * WHY: Handle contact page configuration and initialization
 * HOW: JavaScript module with proper imports and exports
 * IMPORTANCE: Separates concerns and follows industry standards
 */

import CONFIG from './config/config.js';

// Initialize configuration
window.CONFIG = {
    api: CONFIG.api,
    features: CONFIG.features
};

// Initialize contact page
function initializeContactPage() {
    // Any contact page specific initialization can go here
    console.log('Contact page initialized');
    
    // Note: Background image is handled by script.js (initApp function)
    // No need to duplicate background image handling here
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeContactPage);

// Export for potential use in other modules
export { initializeContactPage };
